/* eslint-disable no-plusplus */
import { SaltDocument } from '../SaltDocument';

const mapTemplate = require('./maps_simple');

class MapTranspiler {
    generateSalt(dialog) {
        const document = new SaltDocument(mapTemplate);
        const viewEl = document.getByExpr('**.view');
        document.singleSelectNode(viewEl);
        // @TODO alias, viewAlias - we may want to allow salt to also reference user defined aliases
        const { view } = dialog;
        const viewId = SaltDocument.getViewId(view);
        document.setAttribute('id', viewId);
        return document.rootNode;
    }
}

const mapTranspiler = new MapTranspiler();
export default mapTranspiler;
